import SelectLocaleDropdown from './SelectLocaleDropdown';

export default SelectLocaleDropdown;
export * from './SelectLocaleDropdown';
